import { API as GRAPHAPI, Auth } from 'aws-amplify';
import * as mutations from "../graphql/mutations";
import PreferenceService from "../services/preference";
import EnvironmentService from "./environment";
import axios from "axios";
import Authorization from "./authorization";

const RESTAPI = axios.create({
    baseURL: `${EnvironmentService.baseURL()}/api`,
    timeout: 25000,
    responseType: "json"
});

class PostService {
    static async savePost(caption, assetURL, isAdult) {
        return await GRAPHAPI.graphql({
            query: mutations.createSocialPost,
            variables: {
                text: caption,
                assetPath: assetURL,
                isAdult: isAdult
            }
        }, {
            Authorization: (await Auth.currentSession()).getIdToken().getJwtToken()
        });
    }

    static async fetchPosts(nextKey, limit) {
        let path = `/social/posts`;
        let myInit = {
            headers: {...(await Authorization.authorizationHeader())},
            queryStringParameters: {},
            response: true
        };

        if (PreferenceService.shouldFilterAdult()) {
            myInit['queryStringParameters']['filterAttribute[is_adult]'] = false;
        }

        if (limit) {
            myInit['queryStringParameters']['limit'] = limit;
        }

        if (nextKey) {
            myInit['queryStringParameters']['nextKey'] = nextKey;
        }


        return await RESTAPI.get(path, {params: myInit['queryStringParameters'], headers: myInit["headers"]});
    }

    static async fetchPostById(postId) {
        let myInit = {
            headers: {...(await Authorization.authorizationHeader())},
            queryStringParameters: { 'filterAttribute[_id]': postId, limit: 1 }
        };
        return await RESTAPI.get('/social/posts', { params: myInit.queryStringParameters, headers: myInit.headers });
    }

    static async saveComment(postId, text) {
        return await RESTAPI.put(
            `/social/posts/${encodeURIComponent(postId)}/comments`,
            { text },
            { headers: { ...(await Authorization.authorizationHeader()) } }
        );
    }

    static async fetchPostsForUserName(publicName, nextKey, limit) {
        let path = '/social/posts';
        let myInit = {
            headers: {...(await Authorization.authorizationHeader())},
            response: true
        };

        myInit['queryStringParameters'] = {
            'filterAttribute[author.publicName]': publicName,
        };

        if (PreferenceService.shouldFilterAdult()) {
            myInit['queryStringParameters']['filterAttribute[is_adult]'] = false;
        }

        if (limit) {
            myInit['queryStringParameters']['limit'] = limit;
        }

        if (nextKey) {
            myInit['queryStringParameters']['nextKey'] = nextKey;
        }

        return await RESTAPI.get(path, {params: myInit['queryStringParameters'], headers: myInit["headers"]});
    }
}

export default PostService;
